import React from "react";
import Loader from "@amzn/meridian/esm/components/loader";
import {Column, Row, Theme, Text} from "@amzn/meridian";
import aimsTheme from "../../meridian-theme-aims.json";

// Transcription Loading view
const TranscribeLoading = () => {
  return (
    <Column alignmentHorizontal="center" width="380px" spacing="none" spacingInset="none">
      <Column height="40px" />
        <Column height="64px">
          <Row spacing="none" spacingInset="none">
            <Theme palette={aimsTheme}>
              <Loader />
            </Theme>
          </Row>
        </Column>
        <Column height="32px" spacing="none" />
        <Column>
          <Row spacing="none" spacingInset="none">
            <Text fontFamily="amazonEmber" type="h50" alignment="center">
              Starting transcription...
            </Text>
          </Row>
        </Column>
    </Column>
  );
};

export default TranscribeLoading;
